//import React from 'react';
import { sbaas } from '@/config';
//import { RedoOutlined } from '@ant-design/icons';
//import { Header } from 'antd/lib/layout/layout';
import React, { useState, useEffect, Fragment } from 'react';
//import { Layer, Stage, Line } from 'react-konva';
import { RouteComponentProps } from 'react-router-dom';
// import locale from 'antd/lib/date-picker/locale/id_ID';
import 'moment/locale/id';
//import { Button, Checkbox, Form, Input, Modal, Radio, Row, Select } from 'antd';
import { Button, Row } from 'antd';

const ContactServiceNoTitle = ({  }: RouteComponentProps) => {
  const [email, setEmail] = useState('');
  const retrieveEmail = async () => {
    try {
      await sbaas
        .script('contact_service_conf')
        .get()
        .then(res => {
          setEmail(res.data.data.email);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    retrieveEmail();
  });
  return (
    <Fragment>
      <Row>
        <div className="submit-form-content">
          <div className="contact-service-box">
            <p>
              Regarding Data Subject Right about data retention/revocation and
              data destruction, if you have consent about personal data
              protection and are planning to resign from the company or you are
              a customer that previously submited your data to S-Champion from
              using the Store 2 U/Pre-Order/Pick Up features and want to
              remove/update your personal data information please email to{' '}
              <b>{email}</b>.
            </p>
            <p>
              We will delete/update all your saved personal data on the system,
              once the process complete email notification will be sent to your
              registered email.
            </p>
            <p>Thank you.</p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                type="primary"
                size="large"
                onClick={() => {
                  window.open(
                    'https://mail.google.com/mail/?view=cm&ui=2&tf=0&fs=1&to=' +
                      email +
                      '&su=' +
                      'Request - Delete S-Champion Account' +
                      '&body=' +
                      'Hi srin operation, %0a%0aI would like to remove my S-Champion/SC-CONFIG account, details are below:%0aEmail: %0aFull Name: %0aReason to delete Account: %0a%0aThank you',
                    '_blank',
                  );
                }}
              >
                {' '}
                Contact Us{' '}
              </Button>
            </div>
          </div>
        </div>
      </Row>
    </Fragment>
  );
};
export default ContactServiceNoTitle;
